import { Tooltip } from "@radix-ui/themes";
import { motion } from "framer-motion";
import { useState } from "react";

interface TemplatePackTileProps {
  name: string;
  photoCount?: number;
  imageUrl: string;
  onClick: () => void;
  className?: string;
}

export const TemplatePackTile = ({
  name,
  photoCount,
  imageUrl,
  onClick,
  className = "h-full",
}: TemplatePackTileProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div
      className={`p-1 box-border ${className} cursor-pointer hover:opacity-80 transition-opacity duration-200`}
      onClick={onClick}
    >
      <div className="border-4 overflow-hidden rounded-md border-slate-100 dark:border-slate-900 h-full relative bg-slate-100 dark:bg-slate-800">
        <motion.img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover"
          initial={{ opacity: 0 }}
          animate={{ opacity: isLoaded ? 1 : 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          onLoad={() => setIsLoaded(true)}
        />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: isLoaded ? 1 : 0 }}
          transition={{ duration: 0.3, ease: "easeOut", delay: 0.1 }}
        >
          <Tooltip content={name}>
            <div className="rounded-full h-6 text-center p-1 px-2 bg-blue-600 text-white text-xs bottom-1 left-1 absolute max-w-[70%] overflow-hidden whitespace-nowrap text-ellipsis">
              {name}
            </div>
          </Tooltip>
          {photoCount !== undefined && (
            <Tooltip
              content={`${photoCount} photo${photoCount > 1 ? "s" : ""}`}
            >
              <div className="rounded-full w-6 h-6 text-center p-1 bg-blue-600 text-white text-xs bottom-1 right-1 absolute">
                x{photoCount}
              </div>
            </Tooltip>
          )}
        </motion.div>
      </div>
    </div>
  );
};
